import { Button } from '@podiumhq/design-system';
import { trialButtonStyles } from '../styles';

export const TrialButtonWithLoading = ({
  buttonLabel = 'Continue',
  isLoading,
  size = 'md',
  variant = 'primary',
  ...props
}) => (
  <Button
    isLoading={isLoading}
    size={size}
    variant={variant}
    {...trialButtonStyles}
    {...props}
  >
    {isLoading ? '' : buttonLabel}
  </Button>
);
